import {IExchange} from 'types/models/Exchange';

export const FETCH_EXCHANGES_DATA = 'FETCH_EXCHANGES_DATA';
export const FETCH_EXCHANGES_DATA_SUCCESS = 'FETCH_EXCHANGES_DATA_SUCCESS';
export const FETCH_EXCHANGES_DATA_ERROR = 'FETCH_EXCHANGES_DATA_ERROR';

export const UPDATE_EXCHANGES_DATA = 'UPDATE_EXCHANGES_DATA';

export interface FetchExchangesData {
  type: typeof FETCH_EXCHANGES_DATA;
}

export interface FetchExchangesDataError {
  type: typeof FETCH_EXCHANGES_DATA_ERROR;
}

export interface FetchExchangesDataSuccess {
  type: typeof FETCH_EXCHANGES_DATA_SUCCESS;
  payload: IExchange[];
}

export interface UpdateExchangesData {
  type: typeof UPDATE_EXCHANGES_DATA;
  payload: {
    last: number;
    slug: string;
  };
}

export type ExchangesActionTypes =
  | FetchExchangesData
  | FetchExchangesDataError
  | FetchExchangesDataSuccess
  | UpdateExchangesData;
